import { Link } from "react-router-dom";
import Logo from "../common/Logo";
import { company, industries } from "../../lib/content";

const nav = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Mythoros©", to: "/mythoros" },
  { label: "Industries", to: "/industries" },
  { label: "Process", to: "/process" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

const legal = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms of Use", to: "/terms-of-use" },
  { label: "Accessibility", to: "/accessibility" },
];

function Column({ title, children }) {
  return (
    <div>
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-kv-steel mb-5">{title}</div>
      <ul className="space-y-3">{children}</ul>
    </div>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-kv-steel/20 bg-kv-bg overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 kv-grid-bg opacity-20" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        {/* Display CTA band */}
        <div className="py-20 md:py-28 border-b border-kv-steel/20">
          <h2 className="font-display text-4xl sm:text-5xl md:text-7xl font-medium tracking-tight text-kv-off leading-[0.98] text-balance max-w-4xl">
            Build the next version of your business.
          </h2>
          <div className="mt-8">
            <Link to="/contact" data-testid="footer-strategy-call" className="group inline-flex items-center gap-3 font-body text-lg text-kv-electric hover:text-kv-off transition-colors">
              Start with a strategy session
              <span className="h-px w-10 bg-kv-electric group-hover:w-16 transition-all duration-300" />
            </Link>
          </div>
        </div>

        {/* Link grid */}
        <div className="py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Logo variant="stacked" className="h-16 w-auto" />
            <p className="mt-5 font-body text-sm text-kv-steel max-w-xs leading-relaxed">
              Strategy, systems, and intelligent execution — technology designed around the way your business actually works.
            </p>
          </div>
          <Column title="Navigate">
            {nav.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="font-body text-sm text-kv-grey hover:text-kv-off transition-colors">{n.label}</Link>
              </li>
            ))}
          </Column>
          <Column title="Industries">
            {industries.slice(0, 6).map((i) => (
              <li key={i.name}>
                <Link to="/industries" className="font-body text-sm text-kv-grey hover:text-kv-off transition-colors">{i.name}</Link>
              </li>
            ))}
          </Column>
          <Column title="Company">
            {legal.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="font-body text-sm text-kv-grey hover:text-kv-off transition-colors">{n.label}</Link>
              </li>
            ))}
            <li>
              <a href={`mailto:${company.email}`} className="font-body text-sm text-kv-grey hover:text-kv-off transition-colors">{company.email}</a>
            </li>
          </Column>
        </div>

        {/* Bottom bar */}
        <div className="py-8 border-t border-kv-steel/20 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-kv-steel">
            © {year} {company.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {company.social.map((s) => (
              <a key={s.label} href={s.href} className="font-mono text-[11px] uppercase tracking-[0.16em] text-kv-steel hover:text-kv-off transition-colors" aria-label={s.label}>
                {s.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
